module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-7.3f5195cf.svg";